// import { customUseEffect } from "../../../../../../common";
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { CommonCurdPopUp, ConfirmDialog, MuiDataGrid } from "../../components";
import { GET_ALL_STATUS_EXCEL_DOWNLOAD } from "../../utils/routes";
import { getDownLoadAssessmentPie } from "../../features/dashboard/dashboardSlice";
import { isCheckingAssessmentType } from "../../components/common/IsCheckingAssessmentType";
import { dateSortComparator } from "../../components/common/dataValidation";
// import CommonErrorMessage from "../../../../../../common/error-message/CommonErrorMessage";
// import { deleteProjectGoal, getProjectGoalsByStatus } from "../../../../../../../features/project/projectConfig/projectGoalSlice";
// import DateFns from 'date-fns';
// import ViewGoalDetails from "../../../../viewComponents/project/ViewGoalDetails";
// -------------------------------------------------------------------------------
const ViewAssessmentStatusDetails = ({ ...props }) => {
  // try {
  const [showDetail, setShowDetail] = useState(false);
  const [showDetailData, setShowDetailData] = useState(false);
  const dispatch = useDispatch();
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { customerStatusDetails } = useSelector((state) => ({ ...state?.dashboard }));
  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };


  const getFunction = () => {
    // dispatch(getProjectGoalsByStatus(prop?.data));
  };



  function getCutoffDate(value,  params) {
    if (params?.cutOffDate) {
      const utcTimestamp = params.cutOffDate;
      const date = new Date(utcTimestamp);

      // Extract components
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    }
    return "";
  }


  const data = {
    rows: customerStatusDetails?.length > 0 ? customerStatusDetails : [],
    columns: [
      {
        field: "assessmentTypeName",
        headerName: "Assessment Type",
        renderHeader: () => <strong>Assessment Type</strong>,
        width: 200,
      },
      {
        field: "customerName",
        headerName: "Customer",
        renderHeader: () => <strong>Customer</strong>,
        width: 200,
      },
      {
        field: "accountName",
        headerName: "Account",
        renderHeader: () => <strong>Account</strong>,

        width: 200,
      },
      {
        field: "assessmentTemplateName",
        headerName: "Assessment Name",
        renderHeader: () => <strong>Assessment Name</strong>,

        width: 230,
      },
      // {
      //   field: "userName",
      //   headerName: "User Name",
      //   renderHeader: () => <strong>User Name</strong>,
      //   valueGetter: (params) => `${params?.row?.firstName} ${params?.row?.lastName}`,

      //   width: 250,
      // },
      {
        field: "clientName",
        headerName: "Client Name",
        renderHeader: () => <strong>Client Name</strong>,
        valueGetter: (value,params) => `${params?.firstName} ${params?.lastName}`,
        width: 250,
      },
      {
        field: "email",
        headerName: "Client Email",
        renderHeader: () => <strong>Client Email</strong>,


        width: 250,
      },

      {
        field: "cutOffDate",
        headerName: "Cut Off Date",
        renderHeader: () => <strong>Cut Off Date</strong>,
        valueGetter: getCutoffDate,
        sortComparator: dateSortComparator,
        width: 200,
      },
    ],
  };
  const handleDelete = () => {
    try {
      let data = {
        id: showDetailData[0]?.id,
      };
      // dispatch(deleteProjectGoal(data)).then((res) => {
      //   if (res?.payload?.data?.ok) {
      //     setTimeout(() => {
      //       getFunction();
      //       handleCloseConfirmDialog();
      //       setShowDetailData(false);
      //       props?.close(false);
      //     }, 2000);
      //   }
      // });
    } catch (e) {
    
    }
  };
  const showDeleteFunction = () => {

    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDelete(),
    });
  }




  const downLoadFunc = () => {
    let body = {
      fromDate: props?.downloadData?.fromDate,
      endDate: props?.downloadData?.endDate,
      accountId: props?.downloadData?.accountId,
      customerId: props?.downloadData?.customerId,
      status: props?.downloadData?.status,
      assessmentTypeId : props?.assessmentTypeId,
    }

    dispatch(getDownLoadAssessmentPie(body))
  }

  // try {
  return (
    <>
      {!showDetail && <CommonCurdPopUp
        isDownload={true}
        TARGET_URL={GET_ALL_STATUS_EXCEL_DOWNLOAD}
        targetId={props?.statusTracking}
        downloadFunc={downLoadFunc}
        heading={`Details for Assessment Status `}
        bigScreen={true}
        close={() => props.close()}
      >
        <div
          style={{ marginLeft: "20px", marginRight: "20px" }}
          className="res_tcTestData"
        >
          <MuiDataGrid

            data={data}
            select={(item) => {
              if (item.length > 0) {
                setShowDetailData(item);
                // setShowDetail(true);
              }
            }}
          />
        </div>
      </ CommonCurdPopUp>}

      {/* {
          showDetail && (
            <ViewGoalDetails
              open={showDetail}
              close={() => setShowDetail(false)}
              data={showDetailData[0]}
              showDeleteFunction={showDeleteFunction}
              getFunction={getFunction}
            />
          )} */}



      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
    </>
  );
 
};

const mapStateToProps = (state) => ({
  projectGoal: state?.projectGoal,
  myProject: state?.myProject,
});

export default connect(mapStateToProps, {
})(ViewAssessmentStatusDetails);
